import { api } from '@/lib/axios';
import { Tag, CreateTagDto, UpdateTagDto } from '@caruso/types';

export const tagsService = {
  async getAll(): Promise<Tag[]> {
    const response = await api.get<Tag[]>('/tags');
    return response.data;
  },

  async getById(id: string): Promise<Tag> {
    const response = await api.get<Tag>(`/tags/${id}`);
    return response.data;
  },

  async create(data: CreateTagDto): Promise<Tag> {
    const response = await api.post<Tag>('/tags', data);
    return response.data;
  },

  async update(id: string, data: UpdateTagDto): Promise<Tag> {
    const response = await api.patch<Tag>(`/tags/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/tags/${id}`);
  },

  async findOrCreate(name: string, color?: string): Promise<Tag> {
    const response = await api.post<Tag>('/tags/find-or-create', { name, color });
    return response.data;
  },
};